import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import FilterTab from "../../../../ReusableComponents/FilterDropDown/FilterTab";
import { useEffect } from "react";

export default function FinListPassportRenwal({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const dispatch = useDispatch();
  const [searchWords, setSearchWords] = useState([]);
  const [filter, setFiltered] = React.useState(list?.data);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filter || []);

  function filterStatus(item) {
    if (item === "All") {
      setFiltered(list?.data);
      return;
    }
    setFiltered(list?.data.filter((emp) => emp.passport_status === item));
  }

  useEffect(() => {
    setFiltered(list?.data);
  }, [list]);

  const update = async (type) => {
    try {
      const res = await nodeinstance.post(
        "/passport-renewal/updatePayment/",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully.",
            color: "success",
          })
        );
        updateData("");
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <Search
          searchKey={["employee_id", "name", "client_name","iqama_number","nationality"]}
          setSearchWords={setSearchWords}
        />

        <FilterTab
          changeHandeler={filterStatus}
          status={[
            "All",
            "Passport Vaild",
            "Passport Renewed",
            "Payment Pending",
            "Payment Done",
          ]}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[2300px]">
            <div className="grid grid-cols-table-fin-passport gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-fin-passport gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.new_passport_no
                          ? list.new_passport_no
                          : list.passport_number || "-"
                      }
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.new_passport_expiry_date
                          ? list.new_passport_expiry_date
                          : list.passport_expiry_date || "-"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.new_passport_issue_date
                          ? list.new_passport_issue_date
                          : list.passport_issue_date || "-"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.borne_by || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.renewal_fees || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.passport_status || "-"}
                    />
                  </p>

                  <button
                    className={
                      list.passport_status === "Payment Pending"
                        ? "bg-red px-2 rounded-md text-white text-xs p-2 w-30"
                        : "px-2 rounded-md text-white text-xs p-2 w-30 bg-gray "
                    }
                    disabled={
                      list.passport_status === "Payment Pending" ? false : true
                    }
                    onClick={() => {
                      update({
                        employee_id: list.employee_id,
                        status: "Payment Done",
                      });
                    }}
                  >
                    Update status To Payment Done
                  </button>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
      <Pagination />
      {/* <CountPerPage />
      <div
        className={`grid grid-cols-table- auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {list?.isLoading && <LoadingWithLable className="col-span-6" />}
        {!list?.isLoading && <NoDataFound />}

        {!list?.isLoading
          ? currentList?.map((list, index) => (
              
            ))
          : ""}
      </div>
      <Pagination /> */}
    </>
  );
}
